import type { CSSProperties } from 'react'
import { Linkify, useHtmlLinkHandler } from '../lib/Linkify'

// Описание челленджа приходит как HTML (rich-text из админки, санитайзится на сервере).
// Старые челленджи — простой текст; рендерим его с сохранением переносов.
export const isHtml = (s: string) => /<[a-z][\s\S]*>/i.test(s)

export function stripTags(html: string): string {
  if (!html) return ''
  return html
    .replace(/<\/(?:p|div|li|h[1-6])\s*>/gi, ' ')
    .replace(/<br\s*\/?\s*>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim()
}

/** Рендер описания: HTML — как разметку (клики по ссылкам — через Telegram SDK),
 *  иначе как текст с переносами и автолинкованием URL / t.me / @username. */
export function RichDesc({ html, className, style }: { html: string; className?: string; style?: CSSProperties }) {
  const onLinkClick = useHtmlLinkHandler()
  if (isHtml(html)) {
    return (
      <div
        className={className}
        style={style}
        onClick={onLinkClick}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    )
  }
  return (
    <Linkify as="div" className={className} style={{ whiteSpace: 'pre-wrap', ...style }}>
      {html}
    </Linkify>
  )
}
